import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const DOT_SIZE = '8px';

/** @param {any} props */
export default function NotificationDot({
  top = '0px',
  right = '0px',
  bgClassName = 'rubber'
}) {
  return (
    <div
      data-test-id="breeder-news-notification-dot"
      className={classnames(
        'NotificationDot absolute ba bw1 b--white br-100',
        bgClassName
      )}
      style={{ top, right, height: DOT_SIZE, width: DOT_SIZE }}
    />
  );
}

NotificationDot.propTypes = {
  top: PropTypes.string,
  right: PropTypes.string,
  bgClassName: PropTypes.string
};
